import { StatusBadge } from "@/components/StatusBadge";
import { Link } from "react-router-dom";
import { ExternalLink, ShieldCheck } from "lucide-react";

export function KatlasReceiptCard({ receipt, showLink = true }) {
  if (!receipt) return null;
  const status = receipt.evidence_status || receipt.verification_status;
  return (
    <div
      data-testid="katlas-receipt-card"
      className="overflow-hidden rounded-2xl border border-katlas-blue/40 bg-katlas-navy text-white"
    >
      <div className="flex items-center justify-between gap-3 border-b border-white/10 px-5 py-4">
        <div className="flex items-center gap-2">
          <ShieldCheck className="h-4 w-4 text-katlas-blue" />
          <span className="font-display text-sm font-semibold">KATLAS receipt</span>
        </div>
        <StatusBadge status={status} />
      </div>

      <div className="space-y-3 px-5 py-5">
        <Row label="Action" value={receipt.action} mono />
        <Row label="Custody subject" value={receipt.custody_subject_ref} mono />
        <Row label="Authority role" value={receipt.authority_role} mono />
        <Row label="Decision" value={receipt.decision} />
        <Row label="Attestation" value={receipt.attestation_ref || "—"} mono />
        <Row label="Receipt hash" value={receipt.hash} mono />

        <div className="pt-1">
          <p className="text-[11px] uppercase tracking-[0.14em] text-white/50">Shared evidence (refs only)</p>
          <div className="mt-2 flex flex-wrap gap-2">
            {(receipt.shared_evidence_refs || []).map((r) => (
              <span key={r} className="rounded border border-white/15 bg-white/5 px-2 py-1 font-mono text-xs text-white/80">{r}</span>
            ))}
          </div>
          <p className="mt-3 flex items-center gap-2 text-xs text-katlas-receipt">
            <span className="h-1.5 w-1.5 rounded-full bg-katlas-receipt" />
            {receipt.withheld_evidence_count} private item(s) withheld — never sent to the node
          </p>
        </div>

        <p className="border-t border-white/10 pt-3 text-xs leading-relaxed text-white/60">{receipt.receipt_statement}</p>
        <p className="text-xs leading-relaxed text-white/40">{receipt.data_boundary_statement}</p>

        {showLink && (
          <Link
            to={`/r/${encodeURIComponent(receipt.hash)}`}
            data-testid="receipt-view-link"
            className="mt-2 inline-flex items-center gap-1.5 text-sm font-semibold text-katlas-blue hover:underline"
          >
            View public-safe receipt <ExternalLink className="h-3.5 w-3.5" />
          </Link>
        )}
      </div>
    </div>
  );
}

function Row({ label, value, mono }) {
  return (
    <div className="flex items-start justify-between gap-4">
      <span className="text-[11px] uppercase tracking-[0.14em] text-white/50">{label}</span>
      <span className={`text-right text-sm text-white/90 ${mono ? "font-mono break-all" : ""}`}>{value}</span>
    </div>
  );
}
